import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { MaintenanceNoticeService } from './maintenance-notice.service';

@Component({
  selector: 'app-maintenance-banner',
  templateUrl: './maintenance-banner.component.html',
  styleUrl: './maintenance-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaintenanceBannerComponent {
  protected readonly maintenanceNotice = inject(MaintenanceNoticeService);
}
